import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const File = ({
  size,
  type,
  theme,
  className,
  dataTestId = "file-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <g clipPath="url(#a)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.334 2a.667.667 0 0 0-.667.667v10.666c0 .368.299.667.667.667h9.333a.667.667 0 0 0 .667-.667V6.666h-2.667a2 2 0 0 1-2-2V2H3.334Zm6.667.943 2.39 2.39h-1.724a.667.667 0 0 1-.666-.667V2.944Zm-8.667-.276a2 2 0 0 1 2-2h6c.177 0 .346.07.471.195l4.667 4.666a.667.667 0 0 1 .195.472v7.333a2 2 0 0 1-2 2H3.334a2 2 0 0 1-2-2V2.667Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </SVGIcon>
);
